if (!customElements.get('vbb-accordion')) {
  customElements.define('vbb-accordion', class Accordion extends HTMLElement {
    constructor() {
      super();

      // Selectors
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.accordion__content');

      // State
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;

      // Accessibility: prefers-reduced-motion
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Event Listener
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    onClick(e) {
      e.preventDefault();

      this.details.style.overflow = 'hidden';
      if (this.prefersReducedMotion) {
        // Instantly open/close without animation
        if (!this.details.open) {
          this.details.open = true;
        } else {
          this.details.open = false;
        }
        this.details.style.height = '';
        this.details.style.overflow = '';
        return;
      }
      if (this.isClosing || !this.details.open) {
        this.open();
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }

    shrink() {
      if (this.prefersReducedMotion) {
        this.details.open = false;
        this.details.style.height = '';
        this.details.style.overflow = '';
        return;
      }
      this.isClosing = true;
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      const duration = this.prefersReducedMotion ? 0 : 100;

      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: duration,
        easing: 'ease-out'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      if (this.prefersReducedMotion) {
        this.details.open = true;
        this.details.style.height = '';
        this.details.style.overflow = '';
        return;
      }
      this.details.style.height = `${this.details.offsetHeight}px`;
      this.details.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      if (this.prefersReducedMotion) {
        this.details.open = true;
        this.details.style.height = '';
        this.details.style.overflow = '';
        return;
      }
      this.isExpanding = true;
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      const duration = this.prefersReducedMotion ? 0 : 200;

      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: duration,
        easing: 'linear'
      });

      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.details.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.details.style.height = this.details.style.overflow = '';
    }
  });
}

if (!customElements.get('vbb-accordion-nav')) {
  customElements.define('vbb-accordion-nav', class AccordionNav extends customElements.get('vbb-accordion') {
    constructor() {
      super();
    }

    onClick(e) {
      console.log('AccordionNav clicked');
      this.closeOtherAccordions();
    }

    closeOtherAccordions() {
      document.querySelectorAll('vbb-accordion-nav details[open]').forEach(openDetails => {
        if (openDetails !== this.details && !this.details.contains(openDetails) && !openDetails.contains(this.details)) {
          openDetails.open = false;
        }
      });
    }
  });
}
